module.exports = __webpack_public_path__ + "img/img19.403dc3c6.jpg";